<template>
    <div class="list-prompt">
        <div v-if="!audioSlug && (!llmResponse || Object.keys(llmResponse).length === 0)" class="hide-show-conditions">
            <span>{{ $f.tc('hideShowAllConditions') }}</span>
            <div class="centerY" style="gap: 6px">
                <div class="btn-show" @click="showAllConditions">{{ $f.tc('show') }}</div>
                <div class="btn-hide" @click="hideAllConditions">{{ $f.tc('hide') }}</div>
            </div>
        </div>
        <div v-if="!audioSlug" class="line"></div>


        <!--List of prompt-->
        <div v-if="!audioSlug && (!llmResponse || Object.keys(llmResponse).length === 0)">
            <div class="item-prompt" v-for="(item, index) in promptList" :key="index">
                <PromptEditor
                    v-model="item.content"
                    :promptList="promptList"
                    :showBtnDelete="promptList.length > 1"
                    :showConditions="item.isShowConditions"
                    :rows="4"
                    :tag="item.tag"
                    :condition-list="item.conditionList"
                    @save="save"
                    @updateTag="newTag => updateTag(newTag, index)"
                    @deleteOrPrompt="deleteOrPrompt(index)"
                    @updateCondition="newCondition => updateCondition(newCondition, index)"
                    @toggleConditions="(newVal) => togglePromptConditions(index, newVal)"
                    @addPromptWithContent="addPromptWithContent"
                    style="flex: 1; padding: 12px"
                ></PromptEditor>
                <div class="line"></div>
            </div>
            <PromptEditor
                v-model="promptFallback.content"
                :rows="4"
                :tag="promptFallback.tag"
                :isFallback="true"
                @save="savePromptFallback"
                style="flex: 1; padding: 12px"
            ></PromptEditor>
        </div>

        <!-- Audio prompt -->
        <div v-if="audioSlug" class="p-12">
            <div class="audio-card">
                <div class="icon-card">
                    <img
                        src="/img/scenario/music-fill.svg"
                        alt="icon-audio"
                        title="Audio prompt"
                        style="width: 32px"
                    >
                </div>
                <div style="flex: 1">
                    <div class="centerY justify-space-between">
                        <div class="centerY" :style="isEdit ? {width: '250px'} : {flex: 1}">
                            <span
                                v-if="!audioActivated"
                                class="name-audio"
                                :style="isEdit ? {maxWidth: '200px'} : {maxWidth: '325px'}"
                                :title="$f.tc('unknownAudio')"
                            >{{ $f.tc('unknown') }}</span>

                            <v-select
                                :items="nodeAudioList"
                                item-text="name"
                                item-value="slug"
                                class="autocomplete-custom"
                                :style="!audioActivated ? {width: '10%'} : ''"
                                v-model="audio"
                                hide-details
                                :readonly="!isEdit"
                                @change="saveAudio"
                                ref="AudioAutocomplete"
                            >
                                <template v-slot:selection="{ item }" class="centerXY">
                                    <div class="centerY">
                                        <span
                                            class="name-audio"
                                            :style="isEdit ? {maxWidth: '200px'} : {maxWidth: '325px'}"
                                            :title="item.name"
                                        >{{ item.name }}</span>
                                        <div
                                            v-if="isEdit"
                                            class="btn-icon-2"
                                            style="height: 22px; width: 22px; margin-left: 3px"
                                            :title="$f.tc('delete') + ' ' + $t('audio')"
                                        >
                                            <img src="/img/scenario/select_grey.svg" alt="icon-select-audio"
                                                 style="width: 10px">
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="centerY">
                            <div
                                v-if="audioActivated && audioActivated.description"
                                class="btn-icon-2"
                                style="height: 26px; width: 26px"
                                :title="audioActivated.description"
                            >
                                <img src="/img/scenario/help-circle.svg" alt="icon-more-info-audio" style="width: 23px">
                            </div>
                            <div
                                v-if="isEdit"
                                class="btn-icon-2"
                                style="height: 26px; width: 26px; margin-left: 3px"
                                @click="removeAudio"
                                :title="$f.tc('delete') + ' ' + $t('audio')"
                            >
                                <img src="/img/scenario/delete-new_red.svg" alt="icon-delete">
                            </div>
                        </div>
                    </div>
                    <div class="centerXY mt-8" style="background: #fff; border-radius: 5px;">
                        <audio :src="audioActivated ? audioActivated.audio : ''" controls
                               style="height: 32px; width: 100%"></audio>
                    </div>
                </div>
            </div>
        </div>

        <!-- LLM Response -->
        <div v-if="llmResponse && Object.keys(llmResponse).length > 0" class="p-12">
            <div>
                <!-- Btn to turn off llm response -->
                <div class="mr-2 btn-icon-2" @click="removeLLMResponse"
                     v-if="isEdit && !audioSlug && (llmResponse && Object.keys(llmResponse).length > 0)"
                     style="position: absolute; top:0; right:0">
                    <img src="/img/scenario/delete-new_red.svg" alt="icon-off-llm-response">
                </div>
            </div>
            <!-- Quick reaction for response -->
            <div>
                <div class="label" style="margin-bottom: 0 !important;">{{ $f.tc('quickReaction.reactionWords') }}</div>
                <div class="centerY">
                    <v-text-field
                        outlined
                        hide-details
                        ref="newQuickReactionWord"
                        type="string"
                        @keypress.enter="addNewReactionWord"
                        v-model="newReactionWord"
                        maxlength="50"
                        placeholder="Quick reaction"
                        class="input-custom"
                        :readonly="!isEdit"
                    ></v-text-field>
                </div>
                <div v-if="reactionWords.length > 0" class="monitoring-bar centerY scrollbar-horizontal-thin">
                    <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap">
                        <div class="tag-item centerXY"
                             v-for="(phrase, phraseIndex) in reactionWords"
                             :key="phrase">
                            {{ phrase }}
                            <img v-if="phrase && isEdit" src="/img/debug/close-circle.svg" alt="icon-close"
                                 @click="deleteReactionWord(phraseIndex)">
                        </div>
                    </div>
                </div>
                <div class="label" style="margin-bottom: 6px !important;"
                     :style="reactionWords.length > 0 ? {} : {marginTop: '4px'}">
                    {{ $f.tc('quickReaction.frequency') }}
                </div>
                <v-text-field
                    outlined
                    hide-details
                    type="number"
                    v-model="frequency"
                    :min="0"
                    :max="100"
                    @focusout="validateNewFrequency"
                    @keypress.enter="validateNewFrequency"
                    class="input-custom input-number mb-2"
                ></v-text-field>
            </div>
            <div class="label" style="margin-bottom: 6px !important">
                {{ $f.tc('llmResponse') }}
            </div>
            <v-select
                hide-details outlined
                v-model="llmResponse.label"
                :items="llmResponseList"
                class="input-custom mb-2"
                :readonly="!isEdit"
                @change="updateResponse"
            ></v-select>
            <div class="centerY">
                <div style="max-width: 30px">
                    <v-checkbox
                        hide-details
                        color="#0052CC"
                        v-model="useKE"
                        @change="enableKE"
                        :readonly="!isEdit"
                    ></v-checkbox>
                </div>
                <div class="label mr-2" style="margin-bottom: 0 !important">{{
                        $f.tc('useKe')
                    }}
                </div>
            </div>
            <div v-if="useKE" class="label" style="margin-bottom: 6px !important">
                {{ $f.tc('keConfig') }}
            </div>
            <v-select
                v-if="useKE"
                hide-details outlined
                v-model="llmResponse.labelKE"
                :items="llmConfigs.filter(item => item.type === 'knowledge_explorer')"
                item-value="label"
                item-text="label"
                class="input-custom mb-2"
                :readonly="!isEdit"
                @change="updateKE"
            ></v-select>
            <div v-if="useKE" class="label" style="margin-bottom: 6px !important">
                {{ $f.tc('keContent') }}
            </div>
            <v-text-field
                v-if="useKE"
                hide-details outlined
                v-model="llmResponse.contentKE"
                class="input-custom"
                :readonly="!isEdit"
                @blur="saveContentKE"
            ></v-text-field>
        </div>

        <!-- Btn add prompt and change type of prompt -->
        <div class="btn-actions">
            <div class="btn-add-or centerY" @click="addPrompt"
                 v-if="isEdit && !audioSlug && (!llmResponse || Object.keys(llmResponse).length === 0)">
                <img src="/img/scenario/add_grey.svg" alt="icon-add-or"
                     style="transform: scale(1.1); margin-right: 4px">
                PROMPT
            </div>

            <!-- Btn to change type to llm response -->
            <div class="btn-add-or centerY" @click="addLLMResponse"
                 v-if="isEdit && !audioSlug && scenarioSetting.version > 1 && (!llmResponse || Object.keys(llmResponse).length === 0)">
                <img src="/img/scenario/add_grey.svg" alt="icon-add-or"
                     style="transform: scale(1.1); margin-right: 4px">
                LLM RESPONSE
            </div>

            <!-- Btn change to type audio -->
            <div class="btn-change-audio centerY" @click="addAudio"
                 v-if="isEdit && !audioSlug && (!llmResponse || Object.keys(llmResponse).length === 0)">
                <img
                    src="/img/scenario/arrow-left-right-fill.svg"
                    alt="icon-change-to-audio"
                    style="height: 15px; margin-right: 2px"
                >
                AUDIO
            </div>
        </div>
    </div>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import PromptEditor from "@/views/Scenario/NodeEditor/process/PromptEditor";
import {mapState} from "vuex";

const defaultFallback = {
    tag: "Fallback",
    content: "",
}

const defaultLLMResponse = {
    label: "",
    reactionWords: "",
    frequency: "100"
}

export default {
    name: "PromptList",
    components: {PromptEditor},
    props: {
        value: Array,
        nodeAudioList: Array,
        audioSlug: String,
        fallback: Object,
        llmResponseList: Array,
        llmResponse: {
            type: Object,
            default: () => {
            }
        },
    },
    data() {
        return {
            promptList: [],
            promptFallback: this.$utils.cloneObject(defaultFallback),
            audio: "",
            reactionWords: [],
            newReactionWord: "",
            frequency: "",
            useKE: false,
        }
    },
    computed: {
        ...mapState({
            scenarioSetting: state => state.scenario.scenario_setting,
            llmConfigs: state => state.scenario.llmConfigs,
        }),
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        audioActivated() {
            return this.nodeAudioList.find(i => i.id === this.audio)
        },
    },
    methods: {
        updateTag(newTag, index) {
            this.promptList[index].tag = newTag
            this.save()
        },
        addAudio() {
            if (this.audioSlug) {
                this.$appService.toastError('Audio already exist')
            }
            if (this.nodeAudioList.length === 0) {
                this.$appService.toastError('Audio list empty')
            }
            this.saveAudio(this.nodeAudioList[0].slug)
        },
        removeAudio() {
            this.saveAudio('')
        },
        saveAudio(value) {
            this.$emit('saveAudio', value)
        },
        addPrompt() {
            let newIndex = 1
            while (this.promptList.find(i => i.tag === `prompt_${newIndex}`)) {
                newIndex++
            }
            this.promptList.push({
                content: "",
                tag: `prompt_${newIndex}`
            })
        },
        addPromptWithContent(content) {
            for (let c of content) {
                let newIndex = 1
                while (this.promptList.find(i => i.tag === `prompt_${newIndex}`)) {
                    newIndex++
                }
                this.promptList.push({
                    content: c,
                    tag: `prompt_${newIndex}`
                })
            }
            this.save()
        },
        deleteOrPrompt(index) {
            if (index > -1) {
                this.promptList.splice(index, 1)
                this.save()
            }
        },
        save() {
            this.$emit('input', this.promptList)
            this.$emit('savePrompts')
        },
        savePromptFallback() {
            this.$emit('updateFallback', this.promptFallback)
        },
        updateCondition(newCondition, index) {
            this.promptList[index].conditionList = newCondition
            this.save()
        },

        // hàm này dùng để ẩn hoặc hiển thị tất cả prompt conditions trong list prompt
        showAllConditions() {
            this.promptList.forEach(prompt => {
                prompt.isShowConditions = true
            })
            this.save()
            this.$forceUpdate()
        },
        hideAllConditions() {
            this.promptList.forEach(prompt => {
                prompt.isShowConditions = false
            })
            this.save()
            this.$forceUpdate()
        },

        // hàm này để toggle mỗi prompt conditions
        togglePromptConditions(idx, newVal) {
            this.promptList[idx].isShowConditions = newVal
            this.save()
        },
        addLLMResponse() {
            if (this.llmResponseList.length === 0) {
                this.$appService.toastError('LLM Response list empty')
                return
            }
            if (!this.llmResponse) {
                let temp = this.$utils.cloneObject(defaultLLMResponse)
                temp.label = this.llmResponseList[0]
                this.saveLLMResponse(temp)
                return
            }
            if (Object.keys(this.llmResponse).length > 0) {
                this.$appService.toastError('LLM Response already exist')
                return
            }
            let temp = this.$utils.cloneObject(defaultLLMResponse)
            temp.label = this.llmResponseList[0]
            this.saveLLMResponse(temp)
        },
        removeLLMResponse() {
            this.saveLLMResponse({})
        },
        updateResponse(value) {
            this.llmResponse.label = value
            this.saveLLMResponse(this.llmResponse)
        },
        saveLLMResponse(value) {
            this.$emit('saveResponse', value)
        },
        addNewReactionWord() {
            let newPhrase = this.newReactionWord.trim()
            // validate duplicate
            if (this.reactionWords.includes(newPhrase)) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsDuplicate'))
                this.newReactionWord = ""
                return
            }
            if (!newPhrase || newPhrase === '') {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordBlank'))
                this.newReactionWord = ""
                return
            }
            if (this.reactionWords.length === 15) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsMax'))
                this.newReactionWord = ""
                return
            }
            this.reactionWords.push(newPhrase)
            this.newReactionWord = ""
            this.llmResponse.reactionWords = this.reactionWords.join(";")
            this.saveLLMResponse(this.llmResponse)
        },
        deleteReactionWord(index) {
            if (this.reactionWords.length === 0) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsEmpty'))
                return
            }
            this.reactionWords.splice(index, 1)
            this.llmResponse.reactionWords = this.reactionWords.join(";")
            this.saveLLMResponse(this.llmResponse)
        },
        validateNewFrequency() {
            if (parseInt(this.frequency) <= -1) {
                this.frequency = 100
            }

            if (!this.frequency) {
                this.frequency = 100
            }

            if (this.frequency > 100) {
                this.frequency = 100
            }

            if (this.frequency < 0) {
                this.frequency = 0
            }
            this.llmResponse.frequency = this.frequency
            this.saveLLMResponse(this.llmResponse)
        },
        enableKE() {
            let KEList = this.llmConfigs.filter(item => item.type === 'knowledge_explorer')
            if (KEList.length === 0 && this.useKE) {
                this.$appService.toastError('KE list empty. Please contact admin to use this feature')
                this.$nextTick(() => {
                    this.useKE = false;
                });
                return
            }
            if (this.useKE) {
                this.llmResponse.labelKE = KEList[0].label
                this.llmResponse.contentKE = "{{$user_input}}"
            } else {
                this.llmResponse.labelKE = ""
                this.llmResponse.contentKE = ""
            }
            this.saveLLMResponse(this.llmResponse)
        },
        saveContentKE() {
            if (!this.llmResponse.contentKE) {
                this.llmResponse.contentKE = "{{$user_input}}"
            }
            this.saveLLMResponse(this.llmResponse)
        },
        updateKE(value) {
            this.llmResponse.labelKE = value
            this.saveLLMResponse(this.llmResponse)
        },
    },
    watch: {
        value: {
            deep: true,
            handler: function () {
                this.promptList = this.value
            }
        },
        fallback: {
            deep: true,
            handler: function () {
                this.promptFallback = this.fallback || this.$utils.cloneObject(defaultFallback)
            }
        },
        audioSlug: {
            immediate: true,
            handler: function (newValue) {
                this.audio = newValue
            }
        },
        llmResponse: {
            immediate: true,
            handler: function (newValue) {
                if (newValue && Object.keys(newValue).length > 0) {
                    this.reactionWords = newValue.reactionWords.length > 0 ? newValue.reactionWords.split(';') : []
                    this.frequency = newValue.frequency
                    this.useKE = !!newValue.labelKE
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.hide-show-conditions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    color: #8f97a6;

    .btn-hide, .btn-show {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 8px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        cursor: pointer;
        font-size: 13px;
        font-family: "open sans semi", serif;
        color: #727885;
        user-select: none;

        &:hover {
            background: #f2f2f2;
        }
    }

    .btn-show {
        background: #0052CC !important;
        color: #FFF !important;
        border-color: #0052CC !important;
    }
}

.list-prompt {
    position: relative;
}

.btn-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    position: absolute;
    right: 8px;
    top: -32px;

    .btn-add-or, .btn-change-audio {
        color: #727885;
        font-family: "open sans bold", serif;
        padding: 2px 8px;
        border-radius: 5px;
        cursor: pointer;
        background: #fff;
        font-size: 13px;
        user-select: none;

        &:hover {
            color: #2c3e50;
        }
    }

}

.line {
    flex: 1;
    height: 1px;
    background: #E4EDFA;
}

.or {
    padding: 0 10px;
    font-family: "open sans semi", serif;
    font-size: 13px;
    color: #0052cc;
    background: #E4EDFA;
    border-radius: 4px;
}

.audio-card {
    display: flex;
    padding: 12px;
    background: #f2f2f2cc;
    border-radius: 5px;
    gap: 10px;

    .icon-card {
        height: 66px;
        width: 66px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #727885;
        border-radius: 4px;
    }
}

.label {
    margin-bottom: 2px !important;
}

.name-audio {
    max-width: 220px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 13px;
    color: #727885 !important;
    font-family: 'open sans bold', serif;
    cursor: default;
}

.input-custom, .audio-custom, .autocomplete-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px !important;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;
            padding: 0 12px;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-messages {
            min-height: 3px !important;
        }
    }
}

.autocomplete-custom {
    ::v-deep {
        .v-input__slot {
            padding: 0 !important;
            background: #f2f2f2cc !important;
            border-color: #f2f2f2cc !important;
            height: 26px !important;
        }

        .v-select__slot {
            height: 26px !important;
        }

        .v-input__append-inner {
            display: none;
        }
    }
}

audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-panel {
    background-color: #fff;
}

.response-config {
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    padding: 10px 12px;
}

.monitoring-bar {
    padding: 8px 0;
    background: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}
</style>
